import { Map } from 'immutable';
import AutoComplete from 'portaltransparencia-common/components/AutoComplete.react.js';
import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import Validation from 'portaltransparencia-common/components/Validation.js';
import {
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';
import {
  addFilterUrl,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import FilterButtons from '../components/FilterButtons.react';
import PageHeader from '../components/PageHeader.react.js';
import NotasExplicativas from '../notaexplicativa/Form.react';
import * as actions from './Actions.js';
import SearchResult from './SearchResult.react.js';

export class FormEstoque extends Component {
  static propTypes = {
    loadCentrosCusto: PropTypes.func.isRequired,
    loadOrgao: PropTypes.func.isRequired,
    pesquisaItens: PropTypes.func.isRequired,
    resetItens: PropTypes.func.isRequired,
    resetCrud: PropTypes.func.isRequired,
    page: PropTypes.object.isRequired,
    errors: PropTypes.object,
    validate: PropTypes.func,
    handleError: PropTypes.func,
    filtros: PropTypes.object,
    onChange: PropTypes.func,
    location: PropTypes.object.isRequired
  };

  componentDidMount() {
    const { loadOrgao, loadCentrosCusto } = this.props;

    loadOrgao().then(() => loadCentrosCusto());
  }

  onChangeFiltro = event => {
    const { onChange } = this.props;

    onChange('filtroItensEstoque', event);
  };

  onPesquisaItens = event => {
    event && event.preventDefault();

    const { validate, handleError } = this.props;

    validate(error => {
      if (handleError(this, error)) {
        return;
      }

      const { page } = this.props;
      const initialPage = page.set('number', 0);

      this.searchWithPage(initialPage);
      this.refs.panelFiltroAlmoxarifado &&
        this.refs.panelFiltroAlmoxarifado.collapse();
    });
  };

  onResetFiltro = () => {
    const { resetItens, resetCrud } = this.props;
    resetCrud('filtroItensEstoque');
    resetItens();
  };

  searchWithPage = page => {
    const { pesquisaItens } = this.props;

    const filter = this.montaFilter(page);

    pesquisaItens(filter);
  };

  montaFilter = function (page) {
    let userInfo = StorageService.getItem('userInfo');
    const { entidade, exercicio } = userInfo;

    let filter = 'entidade=' + entidade.id + '&exercicio=' + exercicio.id;
    const { filtros } = this.props;

    if (filtros.get('data') !== undefined && filtros.get('data').length == 10) {
      filter = addFilterUrl(filter, `data=${filtros.get('data')}`);
    }
    if (filtros.get('orgao') !== undefined) {
      filter = addFilterUrl(
        filter,
        'orgao=' + filtros.getIn(['orgao', 'orgao'])
      );
    }
    if (filtros && filtros.get('centroCusto')) {
      filter = addFilterUrl(
        filter,
        'centroCusto=' + filtros.getIn(['centroCusto', 'centroCusto'])
      );
    }
    if (filtros && filtros.get('produto')) {
      filter = addFilterUrl(filter, 'itemDescricao=' + filtros.get('produto'));
    }

    return addPagination(page, filter);
  };

  getValidatorData = () => {
    const { filtros } = this.props;
    return { orgao: filtros.get('orgao') };
  };

  renderCentrosCusto = data => {
    const key =
      data.getIn(['id', 'entidade']) + '_' + data.getIn(['id', 'centroCusto']);

    return (
      <option key={key} value={data.getIn(['id', 'centroCusto'])}>
        {data.get('descricao')}
      </option>
    );
  };

  renderValue = option => {
    return <span>{`${option.id.centroCusto} - ${option.descricao}`}</span>;
  };

  render() {
    const {
      loadCentrosCusto,
      loadOrgao,
      page,
      errors,
      filtros,
      history
    } = this.props;

    const filter = this.montaFilter(page);

    return (
      <section>
        <PageHeader location={this.props.location} />

        <Panel
          title="Posição de Estoque por Período"
          isForm
          ref="panelFiltroAlmoxarifado"
        >
          <form>
            <Row>
              <Col sm={6}>
                <DatePicker
                  id="data"
                  name="data"
                  ref="data"
                  label="Data"
                  placeholder="Data da Posição de Estoque"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('data')}
                  errors={errors}
                />
              </Col>
              <Col sm={6}>
                <AutoComplete
                  label="Orgão"
                  id="orgao"
                  name="orgao"
                  onLoad={loadOrgao}
                  onChange={this.onChangeFiltro}
                  value={filtros.get('orgao')}
                  errors={errors}
                  placeholder="Selecione o Orgão"
                  clearable
                  valueKey="orgao"
                />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <AutoComplete
                  label="Centro de Custo"
                  id="centroCusto"
                  name="centroCusto"
                  onLoad={loadCentrosCusto}
                  onChange={this.onChangeFiltro}
                  value={filtros.get('centroCusto')}
                  errors={errors}
                  placeholder="Selecione o Centro de Custo"
                  clearable
                  valueKey="centroCusto"
                />
              </Col>
              <Col sm={6}>
                <Input
                  label="Produto"
                  type="text"
                  ref="produto"
                  name="produto"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('produto')}
                  id="produto"
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <FilterButtons
                  onConsulta={this.onPesquisaItens}
                  onReset={this.onResetFiltro}
                />
              </Col>
            </Row>
          </form>
        </Panel>

        <NotasExplicativas pathname={this.props.location.pathname} />

        <SearchResult
          filter={filter}
          itensEstoque={page}
          searchWithPage={this.searchWithPage}
          history={history}
        />

        <SearchPagination page={page} searchWithPage={this.searchWithPage} />
      </section>
    );
  }
}

const validatorTypes = {
  rules: {
    orgao: 'required'
  }
};

function mapStateToProps(state) {
  return {
    page: state.almoxarifado.get('itensEstoque'),
    filtros: state.crud.getIn(['filtroItensEstoque', 'currentRecord'], Map({}))
  };
}

const allActions = {
  ...actions,
  onChange,
  resetCrud
};

FormEstoque = Validation(validatorTypes)(FormEstoque);

export default connect(mapStateToProps, allActions)(FormEstoque);
